<template>
  <div>
    <div class="use-meeting-room">
    
      <div class="root">
        <div class="content">
          <div class="rowHead">
            <template v-for="(item, index) in weeks">
              <div class="empty" v-if="index == 0"></div>
              <div v-else class="headItem">
                {{ item }}
              </div>
            </template>
          </div>
          <div class="rowItem" v-for="(item, index) in list">
            <div
              v-for="(items, i) in weeks"
              style="display: inline-block; border-right: 1px dashed #d9d9d9"
            >
              <div class="columnHead" v-if="i == 0">
                <p>{{ item.content }}</p>
                <p>({{ item.name }})</p>
                <div class="side-line"></div>
              </div>
              <div v-else class="columnItem"></div>
            </div>
          </div>
        </div>
        <div class="topContent">
          <div v-for="item in data" style="display: inline-black">
            <div
              class="item"
              :style="{
                top: `${(item.startSection - 1) * 60 - 38}px`,
                left: `${(item.week - 1) * 103}px`,
                height: `${
                  (item.endSection - item.startSection + 1) * 58.75
                }px`,
                lineHeight: `${
                  (item.endSection - item.startSection + 1) * 52
                }px`,
              }"
            >
              {{ item.course }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ScheduleAll } from "../../API/api";
export default {
  name: "dayCalender",
  props:{
      list:{
          type:Array
      },
      showList:{
        type:Array
      }
  },

  data() {
    return {
      weeks: [
        "",
        "10:00",
        "10:30",
        "11:00",
        "11:30",
        "12:00",
        "12:30",
        "13:00",
        "13:30",
        "14:00",
        "14:30",
        "15:00",
        "15:30",
        "16:00",
        "16:30",
        "17:00",
        "17:30",
        "18:00",
        "18:30",
        "19:00",
        "19:30",
      ],
     
        data: [

        // {
        //   week: 3,
        //   startSection: 1,
        //   endSection: 4,
        //   course: '大学物理'
        // },
        // {
        //   week: 4,
        //   startSection: 5,
        //   endSection: 6,
        //   course: 'English'
        // }
        ],
    };
  },
  computed:{
    showList(){

    }

  },
  created(){
    //   this.getDay(new Date(),0);
  },
  mounted(){
  },
  methods: {
    getRooms() {
      this.$http
        .post(ScheduleAll.rooms, this.qs.stringify(), {
          headers: { Authorization: "Bearer " + this.$cookie.get("token") },
        })
        .then((res) => {
          this.roomList = res.data.retData;
        });
    },
    
  },
};
</script>



<style  scoped lang="less">

.root {
  width: 1150px;
  margin: 0 auto;
  background-color: white;
  position: relative;
  overflow: hidden;
  .content {
    width: 100%;
    display: flex;
    flex-direction: column;
    font-size: 14px;
    font-weight: 400;
    color: rgba(59, 66, 107, 1);
    & > div {
      background: #f8f9fa;
    }
    .rowHead {
      height: 30px;
      line-height: 30px;
      background-color: rgba(45, 142, 248, 0.2);
      display: flex;
      // display: inline-block;
      .empty {
        width: 80px;
        background: #f8f9fa;
        height: 30px;
      }
      .headItem {
        width: 52px;
        text-align: center;
      }
    }
    .rowItem {
      height: 60px;
      // line-height: 60px;
      display: flex;
      border-top: 1px solid #d9d9d9;
      .columnHead {
        width: 80px;
        height: 60px;
        text-align: center;
        background-color: white;
        display: flex;
        justify-content: center;
        flex-direction: column;
      }
      .side-line {
        position: absolute;
        left: 80px;
        top: 30px;
        width: 10px;
        height: 95%;
        opacity: 0.1;
        background: linear-gradient(to right, #d9d9d9 0%, #eeeeee 100%);
      }
      .columnItem {
        width: 51px;
        border-left: 1px solid #e6e8fb;
        text-align: center;
      }
    }
  }
  .topContent {
    position: absolute;
    top: 68px;
    left: 80px;
    width: 700px;
    height: 80px;
    .item {
      width: 102.5px;
      text-align: center;
      position: absolute;
      background-color: white;
      border: 1px solid #e6e8fb;
    }
  }
}
</style>